export default __webpack_public_path__ + "static/media/soesvinget-property-15.b5671879.jpg";